/** @format */

import {styled} from '@mui/material/styles';
import {Button, Box} from '@mui/material';

interface RootProps {
  notesCount: number;
  isActive?: boolean;
}

export const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'notesCount' && prop !== 'isActive',
})<RootProps>(({theme, notesCount, isActive}) => ({
  height: '32px',
  minWidth: '32px',
  width: '32px',
  borderRadius: notesCount > 1 ? theme.spacing(2, 0.5, 2, 2) : theme.spacing(2),
  background: isActive ? '#CCA941' : 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  padding: theme.spacing(1),
  color: isActive
    ? theme.palette.figma_gray_light_4?.main
    : notesCount === 0
      ? 'transparent'
      : '#CCA941',

  '&:hover': {
    color: '#CCA941',
    background: 'linear-gradient(rgba(204, 169, 65, 0.20) 100%), #2D2E32',
  },
}));

export const IconWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',

  '& svg': {
    width: '20px',
    height: '20px',
    '& path': {
      stroke: 'currentColor',
      fill: 'currentColor',
    },
  },
}));

export const Badge = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: theme.spacing(-0.5),
  right: theme.spacing(-0.5),
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '10px',
  fontWeight: '500',
  lineHeight: '12px',
  padding: theme.spacing(0.5),
}));
